import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import {
  ApiTypes,
  FREQUENCY_TYPES,
  HOUSEHOLD_TYPES,
  PERMISSIONS,
} from "../../constants/Constants";
import authContext from "../../context/authContext";
import {
  checkPermission,
  getFrequencyValue,
  isDateRangeFinalized,
  setDateHelper,
  userDetails,
} from "../../utils/Helper";
import calLogo from "../../assets/images/calender.svg";
import DatePicker from "react-datepicker";
import Button from "../../components/ui/Button";
import {
  FrequencyTypesJson,
  IntervalJson,
  MonthTypesJson,
  WeekTypesJson,
} from "../../utils/JSON";
import { yupResolver } from "@hookform/resolvers/yup";
import AddExpensesValidation from "../../validations/expenses/AddExpenses";
import toast from "react-hot-toast";
import ExpensesList from "./ExpensesList";
// import PullToRefresh from 'react-simple-pull-to-refresh';
import PullToRefresh from "../../components/ui/PullToRefresh";
import { Link, useNavigate } from "react-router-dom";
import { Routes } from "../../constants/RouteConstants";
import TopHeader from "../../components/layouts/TopHeader";
import moment from "moment";
import upIcon from '../../assets/images/up-icon.svg'
import downIcon from '../../assets/images/down-icon.svg'
import { Tooltip as ReactTooltip } from "react-tooltip";
import PageLayout from "../../components/ui/PageLayout";
import addIcon from '../../assets/images/add-icon.svg';
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import CustomInput from "../../components/ui/CustomInput";
import Checkbox from "../../components/layouts/CheckBox";
import MultiSelectWithCheckboxes from "../../components/ui/MultiSelectWithCheckboxes";
import chevRight from '../../assets/images/chev-right.svg'
import ProfileImage from "../../components/layouts/ProfileImage";



interface expensesInputs {
  hh_id: string; // Household id
  s_date: string; // Start status
  e_date: string; // End status
  payer: string; // Payer
  is_joint_account?: string; // Payer
  ec_id: string; // Expenses id
  s_between?: string[]; // Shared between
  amount: string; // Amount
  desc: string; // Description
  p_status: string; // Payment status
  f_type: string; // Frequency type
  interval_opt: string; // Frequency type
  f_value: string | null; // Frequency value
  is_f_s: boolean;
  s_days_or_months?: number[];
}
const Expenses = () => {
  const navigate = useNavigate();
  let profile: any = useContext(authContext);
  profile = profile?.data;
  const [finalizedMonths, setFinalizedMonths] = useState([]);
  const hhList = useMakeRequest();
  const expenseCreate = useMakeRequest();
  const hhMembers = useMakeRequest();
  const expensesCategories = useMakeRequest();
  const [payerOptions, setPayerOptions] = useState<any>([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShareBetweenExpanded, setIsShareBetweenExpanded] = useState(false);
  const [isJointAccount, setIsJointAccount] = useState(0);
  const [closeAfterSave, setCloseAfterSave] = useState(false);


  const [selectedExpenseValues, setSelectedExpenseValues]: any = useState({
    ec_id: null,
    payer: null,
    f_type: {
      value: FrequencyTypesJson?.[0]?.value,
      label: FrequencyTypesJson?.[0]?.label,
    },
  });



  const {
    register,
    watch,
    setValue,
    getValues,
    formState: { errors },
    handleSubmit,
    trigger,
    reset,
  } = useForm<expensesInputs>({
    mode: "onChange",
    defaultValues: {
      f_type: String(FREQUENCY_TYPES?.ONCE_ONLY),
      s_between: [],
    },
    resolver: yupResolver(AddExpensesValidation),
  });

  useEffect(() => {
    hhList.makeRequest({
      url: ApiConstants?.GetHousehold,
      payload: { show_all: true },
    });
    expensesCategories.makeRequest({
      url: ApiConstants?.ExpensesCategoriesGet,
      type: ApiTypes?.GET,
    });
  }, []);

  useEffect(() => {
    setValue('s_date', setDateHelper({ date: moment().toDate() }))
  }, [])
  useEffect(() => {
    if (watch('f_type') !== String(FREQUENCY_TYPES?.ONCE_ONLY)) {
      setValue('f_value', "1")
    }
  }, [watch('f_type')])

  useEffect(() => {
    if (watch("hh_id")) {
      hhMembers.makeRequest({
        url: ApiConstants?.GetHouseholdMembers,
        payload: { hh_id: watch("hh_id") },
      });
    }
  }, [watch("hh_id")]);

  useEffect(() => {
    if (hhList?.status) {
      setValue("hh_id", hhList?.data?.data?.[0]?.value);
    }
  }, [hhList?.status]);

  const handleSelectShareBetween = (value: any) => {
    let prevSelected: any = watch("s_between");
    if (prevSelected.includes(value)) {
      prevSelected = prevSelected.filter((item: any) => item !== value);
    } else {
      prevSelected = [...prevSelected, value];
    }
    setValue("s_between", prevSelected);
    trigger("s_between");
  };

  const handleSelectDaysOrMonths = (value: any, type: any) => {
    let prevSelected: any = watch("s_days_or_months");
    if (prevSelected.includes(value)) {
      prevSelected = prevSelected.filter((item: any) => item !== value);
    } else {
      prevSelected = [...prevSelected, value];
    }
    setValue("s_days_or_months", prevSelected);
    trigger("s_days_or_months");
  };

  useEffect(() => {
    if (hhMembers?.status) {
      const transformedData = hhMembers?.data?.data?.map((item: any) => ({
        value: item?.user?.uuid,
        label: profile?.uuid === item?.user?.uuid ? `Me` : item?.user?.name,
      }));
      setPayerOptions(transformedData);
    }
  }, [hhMembers?.status]);

  const onSubmit = (formInputs: expensesInputs) => {
    const payload = {
      ...formInputs,
      e_date: formInputs?.e_date ? formInputs?.e_date : formInputs?.s_date,
    };
    if (formInputs.payer == "01") {
      payload.payer = "0"
      payload.is_joint_account = "1"
    }
    // formInputs.payer == "01" ? payload.payer = "0" : formInputs.payer;
    // formInputs.payer == "01" ? payload.is_joint_account = "1" : formInputs.payer;

    const isAlreadyFinalized = isDateRangeFinalized(
      payload?.s_date,
      payload?.e_date,
      finalizedMonths
    );

    if (isAlreadyFinalized) {
      toast.error("The selected month is already finalized.");
      return;
    }


    payload.f_type =
      payload?.f_type === String(FREQUENCY_TYPES?.YEARLY)
        ? String(FREQUENCY_TYPES?.MONTHLY)
        : payload.f_type;


    toast.promise(
      expenseCreate.makeRequest({
        payload: payload,
        url: ApiConstants?.ExpensesCreate,
      }),
      {
        loading: "Processing...",
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );

    if (closeAfterSave) {
      setIsExpanded(false);
    }

    setCloseAfterSave(false);
  };

  useEffect(() => {
    if (expenseCreate?.status) {
      setValue('s_date', setDateHelper({ date: moment().toDate() }))
      setValue("e_date", "");
      setValue("payer", "");
      setValue("ec_id", "");
      setValue("s_between", []);
      setValue("amount", "");
      setValue("desc", "");
      setValue("p_status", "");
      setValue("f_type", String(FREQUENCY_TYPES?.ONCE_ONLY));
      setValue("f_value", null);
      setValue("s_days_or_months", []);
      setSelectedExpenseValues({
        ec_id: null,
        payer: null,
        f_type: {
          value: FrequencyTypesJson?.[0]?.value,
          label: FrequencyTypesJson?.[0]?.label,
        },
      });
    }
  }, [expenseCreate?.status]);

  const handleSelectPayer = (selectedOption: any) => {
    setValue("payer", selectedOption ? selectedOption.value : "");
    setSelectedExpenseValues({
      ...selectedExpenseValues,
      payer: selectedOption,
    });
    if (selectedOption?.value !== "0" || selectedOption?.value !== "01") {
      const allMemb: any = [];
      hhMembers?.data?.data?.length > 0 &&
        hhMembers?.data?.data?.map((memb: any) => {
          allMemb.push(memb?.user?.uuid);
        });
      setValue("s_between", allMemb);
      trigger("s_between");
    }
    trigger("payer");
  };

  useEffect(() => {
    if (!checkPermission(profile?.plan_perms, PERMISSIONS?.EXPENSES)) {
      navigate(Routes?.Dashboard);
    }
    return () => {
      $(".modal-backdrop").remove();
    };
  }, []);

  const handleRefresh = async () => {
    return new Promise(async (resolve: any) => {
      setIsRefresh(true);
      setValue("s_date", "");
      setValue("e_date", "");
      setValue("payer", "");
      setValue("ec_id", "");
      setValue("s_between", []);
      setValue("amount", "");
      setValue("desc", "");
      setValue("p_status", "");
      setValue("f_type", String(FREQUENCY_TYPES?.ONCE_ONLY));
      setValue("f_value", null);
      setValue("s_days_or_months", []);
      setSelectedExpenseValues({
        ec_id: null,
        payer: null,
        f_type: {
          value: FrequencyTypesJson?.[0]?.value,
          label: FrequencyTypesJson?.[0]?.label,
        },
      });
      await hhList.makeRequest({
        url: ApiConstants?.GetHousehold,
        payload: { show_all: true },
      });
      await expensesCategories.makeRequest({
        url: ApiConstants?.ExpensesCategoriesGet,
        type: ApiTypes?.GET,
      });
      await hhMembers.makeRequest({
        url: ApiConstants?.GetHouseholdMembers,
        payload: { hh_id: watch("hh_id") },
      });
      setIsRefresh(false);
      resolve();
    });
  };

  const STATIC_PAYER_OPTIONS = [
    { value: "0", label: "Unpaid" },
    { value: "01", label: "Joint Account" },
  ];

  // Merge static options every time payerOptions is set
  useEffect(() => {
    if (hhMembers?.status) {
      const transformedData = hhMembers?.data?.data?.map((item: any) => ({
        value: item?.user?.uuid,
        label: profile?.uuid === item?.user?.uuid ? `Me` : item?.user?.name,
      }));

      // Merge with static options
      setPayerOptions([...transformedData, ...STATIC_PAYER_OPTIONS]);
    }
  }, [hhMembers?.status]);

  return (
    <PageLayout headerName='Expenses' onlyTitle={false} onRefresh={handleRefresh}>
      <div className="page-padding-x my-3">
        <div className="payment-form">
          <div 
            className="form-header" 
            role="button"
            tabIndex={0}
            onClick={() => setIsExpanded(!isExpanded)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setIsExpanded(!isExpanded);
              }
            }}
          >
            <h2 className="dropdown-title">Add Expenses</h2>
            <img
              src={addIcon}
              alt="Arrow"
              className="arrow-icon"
            />
          </div>

          {isExpanded && (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className={expenseCreate?.loading ? "disabled-ct" : ""}
            >
              <div className="page-padding-x mt-3">
                <div className="row mb-4 g-3">
                  <div className="col-12">

                    <CustomReactSelect
                      required
                      label="Household"
                      options={hhList?.data?.data}
                      value={{
                        value: hhList?.data?.data?.[0]?.value,
                        label: hhList?.data?.data?.[0]?.label,
                      }}
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                      placeholder="Please select household name"
                      onChange={(selectedOption) => {
                        setValue(
                          "hh_id",
                          selectedOption ? selectedOption.value : ""
                        );
                        trigger("hh_id");
                      }}
                      isLoading={hhList?.loading}
                      error={errors}
                      errorName="hh_id"
                    />

                    {/* <div className="com-input-grp">
                      <label className="form-label">Household</label>
                      <div className="custom-select">
                        <Select
                          options={hhList?.data?.data}
                          value={{
                            value: hhList?.data?.data?.[0]?.value,
                            label: hhList?.data?.data?.[0]?.label,
                          }}
                          className="com-r-select"
                          classNamePrefix="com-r-select"
                          placeholder="Please select household name"
                          onChange={(selectedOption) => {
                            setValue(
                              "hh_id",
                              selectedOption ? selectedOption.value : ""
                            );
                            trigger("hh_id");
                          }}
                          closeMenuOnScroll={true}
                          closeMenuOnSelect={true}
                          isLoading={hhList?.loading}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="hh_id"
                          render={({ message }) => (
                            <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                          )}
                        />
                      </div>
                    </div> */}
                  </div>
                  {watch("f_type") == String(FREQUENCY_TYPES?.ONCE_ONLY) ? (
                    <>
                      <div className="col-12">
                        <div className="com-input-grp">
                          <label className="form-label d-block">Date<span className="label-star">*</span></label>
                          <DatePicker
                            className="form-control"
                            placeholderText="MM/DD/YYYY"
                            timeFormat="MM DD YYYY"
                            onKeyDown={(e: any) => e.preventDefault()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            // selected={watch("s_date") as any}
                            selected={
                              watch("s_date")
                                ? moment(watch("s_date")).toDate()
                                : null
                            }
                            showIcon
                            icon={
                              <>
                                <img className="calIcon" src={calLogo} alt="" />
                              </>
                            }
                            onChange={(start_date: any) => {
                              setValue("s_date", setDateHelper({ date: start_date }));
                              trigger("s_date");
                              setValue("e_date", "");
                            }}
                            minDate={
                              profile?.hh_member?.member_type ==
                                HOUSEHOLD_TYPES?.ADMIN
                                ? moment(profile?.hh_member?.billing_date).toDate()
                                : moment(profile?.hh_member?.created_at).toDate()
                            }
                          // maxDate={new Date()}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="s_date"
                            render={({ message }) => (
                              <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                            )}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="col-6">

                    <CustomReactSelect
                      required
                      label="Expense Type"
                      options={expensesCategories?.data?.data}
                      value={selectedExpenseValues?.ec_id}
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                      placeholder="Select"
                      onChange={(selectedOption: any) => {
                        setSelectedExpenseValues({
                          ...selectedExpenseValues,
                          ec_id: selectedOption,
                        });
                        setValue(
                          "ec_id",
                          selectedOption ? selectedOption.value : ""
                        );
                        trigger("ec_id");
                      }}
                      closeMenuOnScroll={true}
                      closeMenuOnSelect={true}
                      isLoading={expensesCategories?.loading}
                      error={errors}
                      errorName="ec_id"
                    />
                    {/* <div className="com-input-grp">
                      <label className="form-label">Expense Type</label>
                      <div className="custom-select">
                        <Select
                          options={expensesCategories?.data?.data}
                          value={selectedExpenseValues?.ec_id}
                          className="com-r-select"
                          classNamePrefix="com-r-select"
                          placeholder="Select"
                          onChange={(selectedOption: any) => {
                            setSelectedExpenseValues({
                              ...selectedExpenseValues,
                              ec_id: selectedOption,
                            });
                            setValue(
                              "ec_id",
                              selectedOption ? selectedOption.value : ""
                            );
                            trigger("ec_id");
                          }}
                          closeMenuOnScroll={true}
                          closeMenuOnSelect={true}
                          isLoading={expensesCategories?.loading}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="ec_id"
                          render={({ message }) => (
                            <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                          )}
                        />
                      </div>
                    </div> */}
                  </div>

                  <div className="col-6">
                    <CustomReactSelect
                      required
                      label="Payer"
                      value={selectedExpenseValues?.payer}
                      options={payerOptions} // no need to spread again here
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                      placeholder="Paid by"
                      isLoading={hhMembers?.loading}
                      onChange={(selectedOption: any) => handleSelectPayer(selectedOption)}
                      error={errors}
                      errorName="payer"
                    />
                    {/* <div className="com-input-grp">
                      <label className="form-label">Payer</label>
                      <div className="custom-select">
                        <Select
                          value={selectedExpenseValues?.payer}
                          options={payerOptions} // no need to spread again here
                          className="com-r-select"
                          classNamePrefix="com-r-select"
                          placeholder="Select payer"
                          isLoading={hhMembers?.loading}
                          onChange={(selectedOption: any) => handleSelectPayer(selectedOption)}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="payer"
                          render={({ message }) => (
                            <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                          )}
                        />
                      </div>
                    </div> */}
                  </div>

                  <div className="col-12">

                    {/* <MultiSelectWithCheckboxes
                      label="Share Between"
                      required={true}
                      members={[
                        { id: 1, name: 'Dianne Russell', avatar: '/path/to/avatar1.jpg' },
                        { id: 2, name: 'Savannah Nguyen', avatar: '/path/to/avatar2.jpg' },
                        { id: 3, name: 'Jane Cooper', avatar: '/path/to/avatar3.jpg' },
                        { id: 4, name: 'Ronald Richards', avatar: '/path/to/avatar4.jpg' }
                      ]}
                      onChange={(selected) => console.log(selected)}
                      error={errors}
                      errorName="members"
                    /> */}
                    <div className="com-input-grp">
                      <label className="form-label">
                        Share Between<span className="label-star">*</span>
                      </label>
                      <div className="custom-select share-between-container">
                        <div className="share-between-header">
                          <div
                            className={`btn-link w-100 d-flex justify-content-between align-items-center p-3 ${isShareBetweenExpanded ? '' : 'collapsed'}`}
                            onClick={() => setIsShareBetweenExpanded(!isShareBetweenExpanded)}
                          >
                            <span className="fw-normal">Members</span>
                            <img src={chevRight} className="chevron-icon" />
                          </div>
                        </div>
                        <div
                          className={`share-between-collapse ${isShareBetweenExpanded ? 'show' : ''}`}
                        >

                          <div className="share-between-body">
                            {hhMembers?.data?.data?.length > 0
                              ? hhMembers?.data?.data?.map(
                                (memb: any, membIndex: any) => {
                                  return (
                                    <div key={membIndex} className="share-member-item">
                                      <div className="d-flex align-items-center gap-3">
                                        {/* <img
                                          src={memb?.user?.profile_pic}
                                          alt={memb?.user?.name}
                                          className="member-avatar"
                                        /> */}
                                        <ProfileImage
                                          size={30}
                                          src={memb?.user?.profile_pic}
                                        />
                                        <span className="member-name">
                                          {profile?.uuid === memb?.user?.uuid
                                            ? `Me`
                                            : memb?.user?.name}
                                        </span>
                                      </div>
                                      <div className="form-check">
                                        <Checkbox
                                          id={memb?.user?.uuid}
                                          onChange={() =>
                                            handleSelectShareBetween(memb?.user?.uuid)
                                          }
                                          checked={watch("s_between")?.includes(
                                            memb?.user?.uuid
                                          )}
                                        />
                                      </div>
                                    </div>
                                  );
                                }
                              )
                              : <div className="text-center py-3 text-muted">No members available</div>}
                          </div>

                        </div>
                        <ErrorMessage
                          errors={errors}
                          name="s_between"
                          render={({ message }) => (
                            <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                          )}
                        />
                      </div>
                    </div>


                    {/* <div className="com-input-grp">
                      <label className="form-label">Share Between</label>
                      <div className="custom-select">
                        <div
                          className="accordion expenses-accordian"
                          id="choresAccordian"
                        >
                          <div className="accordion-item">
                            <h2 className="accordion-header">
                              <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                              >
                                <span className="">Members</span>
                              </button>
                            </h2>
                            <div
                              id="collapseOne"
                              className="accordion-collapse collapse show"
                              data-bs-parent="#choresAccordian"
                            >
                              <div className="accordion-body">
                                <div className="table-responsive">
                                  <table className="table expenses-accordian-table m-0">
                                    <tbody>
                                      {hhMembers?.data?.data?.length > 0
                                        ? hhMembers?.data?.data?.map(
                                          (memb: any, membINdex: any) => {
                                            return (
                                              <tr key={membINdex}>
                                                <td style={{ width: "55px" }}>
                                                  <div className="form-check com-check check-green m-0">
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      onClick={() =>
                                                        handleSelectShareBetween(
                                                          memb?.user?.uuid
                                                        )
                                                      }
                                                      checked={watch(
                                                        "s_between"
                                                      )?.includes(memb?.user?.uuid)}
                                                    // disabled={
                                                    //   watch("payer") ===
                                                    //   memb?.user?.uuid
                                                    // }
                                                    />
                                                  </div>
                                                </td>
                                                <td className="expenses-img-wrap">
                                                  <img
                                                    src={memb?.user?.profile_pic}
                                                    alt=""
                                                  />
                                                </td>
                                                <td>
                                                  {profile?.uuid ===
                                                    memb?.user?.uuid
                                                    ? `Me`
                                                    : memb?.user?.name}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )
                                        : ""}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <ErrorMessage
                            errors={errors}
                            name="s_between"
                            render={({ message }) => (
                              <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                            )}
                          />
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div className="col-12">
                    <CustomInput
                      label="Amount"
                      type="text"
                      placeholder="Enter amount"
                      required
                      {...register('amount')}
                      onInput={(e: any) => {
                        let inputValue = e.target.value;
                        inputValue = inputValue.replace(/[^0-9.]/g, "");
                        const decimalCount = inputValue.split(".").length - 1;
                        if (decimalCount > 1) {
                          const parts = inputValue.split(".");
                          inputValue = parts[0] + "." + parts.slice(1).join("");
                        }
                        const parts = inputValue.split(".");
                        if (parts[0].length > 7) {
                          parts[0] = parts[0].substring(0, 7);
                        }
                        if (parts.length > 1) {
                          parts[1] = parts[1]?.substring(0, 2);
                        }
                        inputValue = parts.join(".");
                        e.target.value = inputValue;
                      }}
                      error={errors.amount?.message}
                    />
                  </div>
                  <div className="col-12">
                    <div className="com-input-grp">
                      <label className="form-label">Description
                        <abbr
                          data-tooltip-id={"description"}
                          className="text-decoration-none cursor-pointer"
                        >
                          <i className="icon-info ms-2"></i>
                        </abbr></label>
                      <ReactTooltip
                        style={{
                          zIndex: "1",
                          wordBreak: "break-word",
                          maxWidth: "90%",
                        }}
                        id={"description"}
                        place="bottom"
                        content={"Description"}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Add description"
                        {...register("desc")}
                        maxLength={50}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="desc"
                        render={({ message }) => (
                          <p className="valid-error">{message}</p>
                        )}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <CustomReactSelect
                      required
                      label="Frequency Type"
                      value={selectedExpenseValues?.f_type}
                      options={FrequencyTypesJson}
                      className="com-r-select"
                      classNamePrefix="com-r-select"
                      placeholder="Frequency type"
                      menuPosition="fixed"
                      menuShouldScrollIntoView={false}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={(selectedOption) => {
                        setSelectedExpenseValues({
                          ...selectedExpenseValues,
                          f_type: selectedOption,
                        });
                        setValue(
                          "f_type",
                          selectedOption ? selectedOption.value : ""
                        );
                        if (
                          watch("f_type") == String(FREQUENCY_TYPES?.ONCE_ONLY)
                        ) {
                          setValue("s_date", "");
                        }
                        // setValue('s_days_or_months', [])
                        // trigger('s_days_or_months')
                        if (
                          selectedOption?.value ===
                          String(FREQUENCY_TYPES?.MONTHLY)
                        ) {
                          const monthArr: any = [];
                          MonthTypesJson?.map(({ value }) => {
                            monthArr.push(value);
                          });
                          setValue("s_days_or_months", monthArr);
                          trigger("s_days_or_months");
                        } else {
                          setValue("s_days_or_months", []);
                          // trigger("s_days_or_months");
                        }
                        trigger("f_type");
                        // trigger("s_date");
                      }}
                      closeMenuOnScroll={true}
                      closeMenuOnSelect={true}
                      error={errors}
                      errorName="f_type"
                    />
                    {/* <div className="com-input-grp">
                      <label className="form-label">Frequency Type<span className="label-star">*</span></label>
                      <div className="custom-select">
                        <Select
                          value={selectedExpenseValues?.f_type}
                          options={FrequencyTypesJson}
                          className="com-r-select"
                          classNamePrefix="com-r-select"
                          placeholder="Frequency type"
                          menuShouldScrollIntoView={false}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(selectedOption) => {
                            setSelectedExpenseValues({
                              ...selectedExpenseValues,
                              f_type: selectedOption,
                            });
                            setValue(
                              "f_type",
                              selectedOption ? selectedOption.value : ""
                            );
                            if (
                              watch("f_type") == String(FREQUENCY_TYPES?.ONCE_ONLY)
                            ) {
                              setValue("s_date", "");
                            }
                            // setValue('s_days_or_months', [])
                            // trigger('s_days_or_months')
                            if (
                              selectedOption?.value ===
                              String(FREQUENCY_TYPES?.MONTHLY)
                            ) {
                              const monthArr: any = [];
                              MonthTypesJson?.map(({ value }) => {
                                monthArr.push(value);
                              });
                              setValue("s_days_or_months", monthArr);
                              trigger("s_days_or_months");
                            } else {
                              setValue("s_days_or_months", []);
                              // trigger("s_days_or_months");
                            }
                            trigger("f_type");
                            // trigger("s_date");
                          }}
                        />
                        <ErrorMessage
                          errors={errors}
                          name="f_type"
                          render={({ message }) => (
                            <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                          )}
                        />
                      </div>
                    </div> */}
                  </div>



                  {watch("f_type") !== String(FREQUENCY_TYPES?.ONCE_ONLY) ? (
                    <>
                      {watch("f_type") === String(FREQUENCY_TYPES?.WEEKLY) ? (
                        <div className="col-12">
                          <div className="com-input-grp mb-4 mt-2">
                            <label className="form-label">Day of the Week</label>
                          </div>
                          <div className="row gy-4">
                            {WeekTypesJson?.map((week, weekIndex) => (
                              <div className="col-6" key={weekIndex}>
                                <div className="form-check com-check">

                                  <Checkbox
                                    id={week?.label}
                                    labelText={week?.label}
                                    onChange={() =>
                                      handleSelectDaysOrMonths(
                                        week?.value,
                                        FREQUENCY_TYPES?.WEEKLY
                                      )
                                    }
                                    checked={watch("s_days_or_months")?.includes(
                                      week?.value
                                    )}
                                  />
                                  {/* <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={week?.label}
                                    onChange={() =>
                                      handleSelectDaysOrMonths(
                                        week?.value,
                                        FREQUENCY_TYPES?.WEEKLY
                                      )
                                    }
                                    checked={watch("s_days_or_months")?.includes(
                                      week?.value
                                    )}
                                  />
                                  <label
                                    className="form-check-label fw-500"
                                    htmlFor={week?.label}
                                  >
                                    {week?.label}
                                  </label> */}
                                </div>
                              </div>
                            ))}
                            <ErrorMessage
                              errors={errors}
                              name="s_days_or_months"
                              render={({ message }) => (
                                <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                              )}
                            />
                          </div>
                        </div>
                      ) : watch("f_type") === String(FREQUENCY_TYPES?.MONTHLY) ||
                        watch("f_type") === String(FREQUENCY_TYPES?.YEARLY) ? (
                        <div className="col-12">
                          <div className="com-input-grp mb-4 mt-2">
                            <label className="form-label">Month of the Year</label>
                          </div>
                          <div className="row gy-4">
                            {MonthTypesJson?.map((month, monthIndex) => (
                              <div className="col-6" key={monthIndex}>
                                <div className="form-check com-check">

                                  <Checkbox
                                    id={month?.label}
                                    labelText={month?.label}
                                    onChange={() =>
                                      handleSelectDaysOrMonths(
                                        month?.value,
                                        FREQUENCY_TYPES?.MONTHLY
                                      )
                                    }
                                    checked={watch("s_days_or_months")?.includes(
                                      month?.value
                                    )}
                                  />
                                  {/* <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={month?.label}
                                    onChange={() =>
                                      handleSelectDaysOrMonths(
                                        month?.value,
                                        FREQUENCY_TYPES?.MONTHLY
                                      )
                                    }
                                    checked={watch("s_days_or_months")?.includes(
                                      month?.value
                                    )}
                                  />
                                  <label
                                    className="form-check-label fw-500"
                                    htmlFor={month?.label}
                                  >
                                    {month?.label}
                                  </label> */}
                                </div>
                              </div>
                            ))}
                            <ErrorMessage
                              errors={errors}
                              name="s_days_or_months"
                              render={({ message }) => (
                                <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                              )}
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="col-12 col-sm-6">
                        <div className="com-input-grp">
                          <label className="form-label d-block">Start Date</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="MM/DD/YYYY"
                            timeFormat="MM DD YYYY"
                            onKeyDown={(e: any) => e.preventDefault()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            // selected={watch("s_date") as any}
                            selected={
                              watch("s_date")
                                ? moment(watch("s_date")).toDate()
                                : null
                            }
                            showIcon
                            icon={
                              <>
                                <img className="calIcon" src={calLogo} alt="" />
                              </>
                            }
                            onChange={(start_date: any) => {
                              setValue("s_date", setDateHelper({ date: start_date }));
                              trigger("s_date");
                              setValue("e_date", "");
                            }}
                            minDate={
                              profile?.hh_member?.member_type ==
                                HOUSEHOLD_TYPES?.ADMIN
                                ? moment(profile?.hh_member?.billing_date).toDate()
                                : moment(profile?.hh_member?.created_at).toDate()
                            }
                          />
                          <ErrorMessage
                            errors={errors}
                            name="s_date"
                            render={({ message }) => (
                              <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="com-input-grp">
                          <label className="form-label d-block">End Date</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="MM/DD/YYYY"
                            timeFormat="MM DD YYYY"
                            onKeyDown={(e: any) => e.preventDefault()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            // selected={watch("e_date") as any}
                            selected={
                              watch("e_date")
                                ? moment(watch("e_date")).toDate()
                                : null
                            }
                            showIcon
                            icon={
                              <>
                                <img className="calIcon" src={calLogo} alt="" />
                              </>
                            }
                            onChange={(start_date: any) => {
                              setValue("e_date", setDateHelper({ date: start_date }));
                              trigger("e_date");
                            }}
                            // minDate={new Date(watch('s_date')+1)}
                            minDate={
                              new Date(
                                new Date(watch("s_date")).setDate(
                                  new Date(watch("s_date")).getDate() + 1
                                )
                              )
                            }
                          />
                          <ErrorMessage
                            errors={errors}
                            name="e_date"
                            render={({ message }) => (
                              <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                            )}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="com-input-grp">
                          <label className="form-label">
                            Interval
                            <abbr
                              data-tooltip-id={"interval"}
                              className="text-decoration-none cursor-pointer"
                            >
                              <i className="icon-info ms-2"></i>
                            </abbr>
                          </label>
                          <ReactTooltip
                            style={{
                              zIndex: "1",
                              wordBreak: "break-word",
                              maxWidth: "90%",
                            }}
                            id={"interval"}
                            place="bottom"
                            content={"Interval"}
                          />
                          <div className="custom-select">
                            <Select
                              options={getFrequencyValue({
                                type: watch("f_type"),
                                sDate: watch("s_date"),
                                eDate: watch("e_date"),
                              })}
                              className="com-r-select"
                              classNamePrefix="com-r-select"
                              placeholder="Interval value"
                              isDisabled={!watch("s_date") || !watch("e_date")}
                              value={watch('f_value') ? { value: watch('f_value'), label: watch('f_value') } : { value: 1, label: 1 }}
                              onChange={(selectedOption) => {
                                setValue(
                                  "f_value",
                                  selectedOption ? String(selectedOption.value) : ""
                                );
                                trigger("f_value");
                              }}
                              menuPortalTarget={document.body}
                              styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="f_value"
                              render={({ message }) => (
                                <p className="valid-error" tabIndex={0} role="alert" aria-live="polite">{message}</p>
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Button
                    className="com-btn com-btn-outline mt-2 mb-4"
                    style={{ width: "50%" }}
                    type="submit"
                    text="submit"
                    loading={expenseCreate?.loading}
                    onClick={() => setCloseAfterSave(false)}
                  >
                    Save & Add Another
                  </Button>

                  <Button
                    style={{ width: "50%" }}
                    onClick={() => setCloseAfterSave(true)}
                    type="submit"
                    className="com-btn mt-2 mb-4"
                  >
                    Save
                  </Button>

                </div>


              </div>
            </form>
          )}
        </div>
      </div>
      <ExpensesList
        payers={payerOptions}
        expensesCategories={expensesCategories}
        expenseCreate={expenseCreate}
        setFinalizedMonths={setFinalizedMonths}
        isRefresh={isRefresh}
      />
    </PageLayout>

  );
};

export default Expenses;
